import React, { useState } from 'react';
import moment from 'moment';
import {
  Row,
  Col,
  Button,
  Table,
  Input,
  Select,
  Popover,
  Pagination,
  Modal,
} from 'antd/lib';
import * as Icons from '@ant-design/icons';
import ModalVisorEmail from '../../common/ModalVisorEmail';

export default ({
  licencias,
  usuario,
  onDelete,
  onReenviarEmail,
  reenviarEmailLoading,
  history,
  total,
  pagina,
  tamPagina,
  cambiarTamañoPagina,
  cambiarPagina,
  setFiltrarPorAPyN,
  setFiltrarOrganismo,
  setFiltrarEstado,
  filtroNombrePadre,
  filtroApellidoPadre,
  filtroOrganismoPadre,
  listaOrganismos,
  filtroEstadoPadre,
  loadingTabla,
}) => {
  const [filtroNombre, setFiltroNombre] = useState(filtroNombrePadre);
  const [filtroApellido, setFiltroApellido] = useState(filtroApellidoPadre);
  const [filtroOrganismo, setFiltroOrganismo] = useState(filtroOrganismoPadre);
  const [filtroEstado, setFiltroEstado] = useState(filtroEstadoPadre);
  const [idLicencia, setIdLicencia] = useState(null);
  const [visibleModalVisorEmail, setVisibleModalVisorEmail] = useState(false);
  const columns = [
    {
      title: 'Fecha Inicio',
      dataIndex: 'fechaInicio',
      width: 120,
      render: fecha => moment(fecha).format('DD-MM-YYYY'),
    },
    {
      title: 'Fecha Fin',
      dataIndex: 'fechaFin',
      width: 120,
      render: fecha => moment(fecha).format('DD-MM-YYYY'),
    },
    {
      title: 'De',
      dataIndex: 'solicitante',
      render: usuario =>
        usuario ? usuario.nombre + ' ' + usuario.apellido : '',
      filterDropdown: (
        <div>
          <Row>
            <Col span={4}>
              <p style={{ margin: 10 }}>Nombre:</p>
            </Col>
            <Col offset={2} span={16}>
              <Input
                value={filtroNombre || filtroNombrePadre}
                style={{ margin: 10 }}
                placeholder="Nombre"
                onChange={e => setFiltroNombre(e.target.value)}
                onPressEnter={() =>
                  setFiltrarPorAPyN({
                    nombreSolicitante: filtroNombre,
                    apellidoSolicitante: filtroApellido,
                  })
                }
              />
            </Col>
          </Row>
          <Row>
            <Col span={4}>
              <p style={{ margin: 10 }}>Apellido:</p>
            </Col>
            <Col offset={2} span={16}>
              <Input
                value={filtroApellido || filtroApellidoPadre}
                style={{ margin: 10 }}
                placeholder="Apellido"
                onChange={e => setFiltroApellido(e.target.value)}
                onPressEnter={() =>
                  setFiltrarPorAPyN({
                    nombreSolicitante: filtroNombre,
                    apellidoSolicitante: filtroApellido,
                  })
                }
              />
            </Col>
          </Row>
          <Row>
            <Col offset={10}>
              <Button
                icon={<Icons.FileSearchOutlined />}
                shape="circle"
                type="primary"
                size="small"
                style={{ margin: '8px 8px' }}
                onClick={() =>
                  setFiltrarPorAPyN({
                    nombreSolicitante: filtroNombre,
                    apellidoSolicitante: filtroApellido,
                  })
                }
              />

              <Button
                icon={<Icons.CloseOutlined />}
                shape="circle"
                size="small"
                type="danger"
                onClick={() => {
                  setFiltrarPorAPyN({
                    nombreSolicitante: null,
                    apellidoSolicitante: null,
                  });
                }}
              />
            </Col>
          </Row>
        </div>
      ),
      filterIcon: () => (
        <Icons.FilterOutlined
          style={{
            color: filtroNombre || filtroApellido ? '#1890ff' : undefined,
          }}
        />
      ),
    },
    {
      title: 'Estado',
      dataIndex: 'estado',
      width: 120,
      render: estado => estado.toUpperCase(),
      filterDropdown: (
        <div>
          <Row>
            <Col span={16}>
              <Select
                style={{ width: 180, margin: '10px 5px' }}
                id="estados"
                placeholder="Estado: "
                onSelect={valor => setFiltroEstado(valor)}
                value={filtroEstado}
              >
                <Select.Option key={'PENDIENTE'} value={'PENDIENTE'}>
                  PENDIENTE
                </Select.Option>
                <Select.Option key={'ACEPTADA'} value={'ACEPTADA'}>
                  ACEPTADA
                </Select.Option>
                <Select.Option
                  key={'PRIMERA APROBACION'}
                  value={'PRIMERA APROBACION'}
                >
                  PRIMERA APROBACION
                </Select.Option>
              </Select>
            </Col>
          </Row>
          <Row>
            <Col offset={10}>
              <Button
                icon={<Icons.FileSearchOutlined />}
                shape="circle"
                type="primary"
                size="small"
                style={{ margin: '8px 8px' }}
                onClick={() => setFiltrarEstado(filtroEstado)}
              />

              <Button
                icon={<Icons.CloseOutlined />}
                shape="circle"
                size="small"
                type="danger"
                onClick={() => setFiltrarEstado(null)}
              />
            </Col>
          </Row>
        </div>
      ),
      filterIcon: () => (
        <Icons.FilterOutlined
          style={{ color: filtroEstado ? '#1890ff' : undefined }}
        />
      ),
    },
    {
      title: 'Eval.',
      key: 'Eval',
      width: 100,
      align: 'center',
      render: licencia =>
        licencia && (licencia.aprobacionFase1 || licencia.aprobacionFase2) ? (
          licencia &&
          licencia.aprobacionFase1 &&
          (licencia.aprobacionFase2 || licencia.fechaEvaluacionFase2) ? (
            <Popover
              content={
                <div>
                  <div>
                    <h3>Evaluacion del Superior a Cargo:</h3>
                    <Row>
                      Fecha:
                      {licencia.fechaEvaluacionFase1
                        ? moment(licencia.fechaEvaluacionFase1).format(
                            'DD/MM/YYYY'
                          )
                        : ''}
                    </Row>
                    <Row>
                      Opinion:
                      {licencia.opinionSupervisor
                        ? licencia.opinionSupervisor
                        : ''}
                    </Row>
                    <Row>
                      Obs:
                      {licencia.observacionSupervisor
                        ? licencia.observacionSupervisor
                        : ''}
                    </Row>
                  </div>
                  <hr />
                  <div>
                    <h3>Evaluacion de la DGJP:</h3>
                    <Row>
                      Fecha:
                      {licencia.fechaEvaluacionFase2
                        ? moment(licencia.fechaEvaluacionFase2).format(
                            'DD/MM/YYYY'
                          )
                        : ''}
                    </Row>
                    <Row>
                      Opinion:
                      {licencia.opinionDGJP ? licencia.opinionDGJP : ''}
                    </Row>
                    <Row>
                      Obs:
                      {licencia.observacionDGJP ? licencia.observacionDGJP : ''}
                    </Row>
                  </div>
                </div>
              }
              title={`Evaluaciones de la licencia`}
            >
              <Icons.SolutionOutlined
                style={{
                  fontSize: '24px',
                  color: licencia.estado === 'ACEPTADA' ? '#00FF00' : '#FF0000',
                }}
              />
            </Popover>
          ) : (
            <Popover
              content={
                <div>
                  <Row>
                    Fecha:
                    {licencia.fechaEvaluacionFase1
                      ? moment(licencia.fechaEvaluacionFase1).format(
                          'DD/MM/YYYY'
                        )
                      : ''}
                  </Row>
                  <Row>
                    Opinion:
                    {licencia.opinionSupervisor
                      ? licencia.opinionSupervisor
                      : ''}
                  </Row>
                  <Row>
                    Obs:
                    {licencia.observacionSupervisor
                      ? licencia.observacionSupervisor
                      : ''}
                  </Row>
                </div>
              }
              title={`Primera Aprobacion`}
            >
              <Icons.SolutionOutlined
                style={{ fontSize: '24px', color: '#0000FF' }}
              />
            </Popover>
          )
        ) : (
          <Icons.SolutionOutlined
            style={{ fontSize: '24px', color: '#878a88' }}
          />
        ),
    },
    {
      title: 'Email',
      width: 100,
      render: (text, record) => (
        <Icons.MailOutlined
          style={{ color: record.enviadoPorEmail ? '#27b504' : '#000000' }}
        />
      ),
    },
    {
      title: 'Organismo',
      dataIndex: 'organismo',
      render: organismo => organismo.nombre,
      filterDropdown: (
        <div>
          <Row>
            <Col span={4}>
              <p style={{ margin: 10 }}>Organismo:</p>
            </Col>
            <Col span={16}>
              <Select
                style={{ width: 415, margin: '10px 5px' }}
                id="organismos"
                placeholder="Seleccione el organismo"
                // disabled={usuario.organismo._id !== '00004'}
                onSelect={valor => setFiltroOrganismo(valor)}
                value={filtroOrganismo}
              >
                {listaOrganismos &&
                  listaOrganismos.map(organismo => (
                    <Select.Option key={organismo._id}>
                      {organismo.nombre}
                    </Select.Option>
                  ))}
              </Select>
            </Col>
          </Row>
          <Row>
            <Col offset={10}>
              <Button
                icon={<Icons.FileSearchOutlined />}
                shape="circle"
                type="primary"
                size="small"
                style={{ margin: '8px 8px' }}
                onClick={() => setFiltrarOrganismo(filtroOrganismo)}
              />

              <Button
                icon={<Icons.CloseOutlined />}
                shape="circle"
                size="small"
                type="danger"
                onClick={() => setFiltrarOrganismo(null)}
              />
            </Col>
          </Row>
        </div>
      ),
      filterIcon: () => (
        <Icons.FilterOutlined
          style={{ color: filtroOrganismo ? '#1890ff' : undefined }}
        />
      ),
    },
    {
      title: 'Motivo',
      dataIndex: 'motivo',
      width: 250,
      ellipsis: true,
      // render: motivo => (
      //   <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
      //     { motivo }
      //   </span>
      // ),
    },
    {
      title: 'Acciones',
      key: 'acciones',
      render: (text, record) => (
        <span>
          {record.estado == 'PENDIENTE' &&
          record.solicitante._id == usuario._id ? (
            <Button
              size="small"
              icon={<Icons.EditOutlined />}
              type="primary"
              style={{ marginRight: 10 }}
              onClick={() => history.push(`/rrhh/licencias/${record._id}/`)}
            >
              Editar
            </Button>
          ) : null}

          {(record.estado == 'PENDIENTE' &&
            record.superior &&
            record.superior._id == usuario._id) ||
          (record.estado !== 'RECHAZADA' &&
            record.aprobacionFase1 &&
            !record.aprobacionFase2 &&
            (usuario.rol === 'DGJP_DIRECTOR' ||
              usuario.rol === 'DGJP_EMPLEADO')) ? (
            <Button
              size="small"
              type="primary"
              icon={<Icons.CheckOutlined />}
              style={{ marginRight: 10 }}
              onClick={() =>
                history.push(`/rrhh/licencias/${record._id}/evaluar`)
              }
            >
              Evaluar
            </Button>
          ) : null}
          <Button
            onClick={() => mostrarModalVisorEmail(record._id)}
            style={{ marginRight: 10 }}
            icon={<Icons.FileSearchOutlined />}
            size="small"
          />
          {!record.enviadoPorEmail &&
            (usuario.rol === 'FUNCIONARIO' ||
              usuario.rol === 'DGJP_DIRECTOR' ||
              usuario.rol === 'DGJP_EMPLEADO') && (
              <Button
                onClick={() => confirmarReenvioEmail(record)}
                style={{ marginRight: 10 }}
                icon={<Icons.MailOutlined />}
                type="primary"
                size="small"
                title="Reenviar email"
                loading={reenviarEmailLoading}
              />
            )}
          <Button
            size="small"
            icon={<Icons.DeleteOutlined />}
            type="danger"
            onClick={() => onDelete(record._id)}
          />
        </span>
      ),
    },
  ];
  const mostrarModalVisorEmail = idLicencia => {
    setIdLicencia(idLicencia);
    setVisibleModalVisorEmail(true);
  };

  const ocultarModalVisorEmail = () => {
    setIdLicencia(null);
    setVisibleModalVisorEmail(false);
  };

  const confirmarReenvioEmail = (licencia) => {
    // Determinar quién recibirá el email basado en el estado y aprobaciones
    let receptor = '';
    let emails = [];
    let descripcion = '';
    
    if (licencia.estado === 'RECHAZADA' || licencia.estado === 'ACEPTADA') {
      // Email de evaluación final al solicitante
      receptor = 'Solicitante';
      emails = [];
      if (licencia.solicitante) {
        emails.push(`${licencia.solicitante.username}@jusneuquen.gov.ar`);
      }
      
      if (licencia.estado === 'ACEPTADA' && licencia.superior) {
        emails.push(`${licencia.superior.username}@jusneuquen.gov.ar`);
        emails.push('djpfd@jusneuquen.gov.ar');
        emails.push('dghnqfd@jusneuquen.gov.ar');
      }
      
      descripcion = licencia.estado === 'ACEPTADA' 
        ? 'Notificación de licencia aprobada'
        : 'Notificación de licencia rechazada';
    } else if (licencia.aprobacionFase1 && !licencia.aprobacionFase2) {
      // Notificación a DGJP
      receptor = 'Dirección General de Justicia de Paz (DGJP)';
      emails = [];
      emails.push('Superior Jerárquico');
      emails.push('Director del Juzgado de Paz');
      emails.push('djpfd@jusneuquen.gov.ar');
      descripcion = 'Nueva licencia pendiente de aprobación final';
    } else {
      // Notificación al superior jerárquico
      receptor = 'Superior Jerárquico';
      emails = [];
      emails.push('Superior)');
      if (licencia.superior) {
        emails.push(`${licencia.superior.username}@jusneuquen.gov.ar`);
      }
      descripcion = 'Nueva licencia pendiente de evaluación';
    }

    Modal.confirm({
      title: '¿Confirmar reenvío de email?',
      icon: <Icons.QuestionCircleOutlined />,
      content: (
        <div>
          <p>¿Está seguro que desea reenviar el email de notificación?</p>
          <div style={{ marginTop: 16, padding: 12, backgroundColor: '#f5f5f5', borderRadius: 4 }}>
            <p style={{ margin: 0, fontWeight: 'bold' }}>Tipo de notificación:</p>
            <p style={{ margin: '4px 0 8px 0', fontSize: '13px' }}>{descripcion}</p>
            
            <p style={{ margin: '8px 0 4px 0', fontWeight: 'bold' }}>Destinatario:</p>
            <p style={{ margin: '4px 0 0 0' }}>{receptor}</p>
            
            <p style={{ margin: '8px 0 4px 0', fontWeight: 'bold' }}>Personas que recibirán la notificación:</p>
            {emails.map((email, index) => (
              <p key={index} style={{ margin: '2px 0 0 8px', fontSize: '12px', color: '#666' }}>
                • {email}
              </p>
            ))}
          </div>
        </div>
      ),
      okText: 'Reenviar',
      cancelText: 'Cancelar',
      onOk() {
        onReenviarEmail(licencia._id);
      },
    });
  };

  const pagination = {
    onChange: page => {
      cambiarPagina(page);
    },
    total: total,
    current: pagina,
    pageSize: tamPagina ? tamPagina : null,
    showSizeChanger: true,
    onShowSizeChange: (current, pageSize) => {
      cambiarTamañoPagina(pageSize);
      cambiarPagina(1);
    },
  };

  return (
    <div>
      <Table
        rowKey="_id"
        columns={columns}
        // pagination={paginationOptions}
        pagination={pagination}
        dataSource={licencias}
        title={() => <h2 style={{ textAlign: 'center' }}> Licencias </h2>}
        locale={{
          emptyText: 'Sin Licencias.',
        }}
        loading={loadingTabla}
      />

      <ModalVisorEmail
        id={idLicencia}
        visibleModalLogsEmail={visibleModalVisorEmail}
        ocultarModalLogsEmail={ocultarModalVisorEmail}
      />
    </div>
  );
};
